import { render, staticRenderFns } from "./1000MigliaItemLabel.vue?vue&type=template&id=b39a645e"
import script from "./1000MigliaItemLabel.vue?vue&type=script&lang=js"
export * from "./1000MigliaItemLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports